import React, { useState, useEffect } from "react";
import Spinner from "../components/common/spinner/Spinner";
import DataTable from "react-data-table-component-with-filter";
import StudyDetails from "./StudyDetails";
import jwtDecode from "../utils/jwtDecode";
import { usePermissionsContext } from "../context/contextPermissions";

import { fetchMetaData } from "../services/apis";

import { useHistory, Link } from "react-router-dom";

import { useAuth0 } from "@auth0/auth0-react";

import "./Search.css";

function Search() {
  const history = useHistory();

  const [campaignData, setCampaignData] = useState();
  const [isLoading, setIsLoading] = useState(true);

  const { user } = useAuth0();
  const { getAccessTokenSilently } = useAuth0();
  const { permissions, setPermissions } = usePermissionsContext();


  const campaignColumns = [
    {
      name: "Study Nº",
      selector: (campaign) => campaign.Study_number,
      sortable: true,
      filterable: true,
    },
    {
      name: "Client",
      selector: (campaign) => campaign.Client,
      sortable: true,
      filterable: true,
    },
    {
      name: "Country",
      selector: (campaign) => campaign.Country,
      sortable: true,
      filterable: true,
    },
    {
      name: "Gender",
      selector: (campaign) => campaign.Gender,
      sortable: true,
      filterable: true,
    },
    {
      name: "Methodology",
      selector: (campaign) => campaign.Method,
      sortable: true,
    },
    {
      name: "Type",
      selector: (campaign) => campaign.Type,
      sortable: true,
    },
    {
      name: "Number of Fragrances",
      selector: (campaign) => campaign.Number_of_fragrances,
    },
  ];

  useEffect(() => {
    async function init() {
      try {
        const jwt = await getAccessTokenSilently();
        localStorage.setItem("jwt", jwt);
        var token = jwtDecode(jwt);

        var tableData = await fetchMetaData(jwt);
        var tableDataReverse = tableData.reverse();
          
        setCampaignData(tableDataReverse);
        setIsLoading(false);
      } catch (ex) {
        // console.log("ex", ex);
        if (ex.response && ex.response.status === 401) {
        }
      }
    }
    init();
  }, []);

  const handleChangeClicked = (study) => {
    return history.push(
      `/view/${study.Ownership}/${study.Client}/${study.Study_number}/${study.Country}/${study.Gender}/candidat/hedonic`
    );
  };


  return (
    <div className="search-page">
      <h1 className="company-name">{permissions.username}</h1>
      {isLoading ? (
        <Spinner />
      ) : (
        <>
          {permissions.studies_details ? (
            <DataTable
              columns={campaignColumns}
              data={campaignData}
              pagination
              onRowClicked={handleChangeClicked}
              Clicked
            />
          ) : (
            <DataTable
              columns={campaignColumns}
              data={campaignData}
              pagination
            />
          )}
        </>
      )}
    </div>
  );
}

export default Search;
